export const ROUTES = {

  SIGNIN: "/",
  SIGNUP: "/signup",
  CONTACT:'/contact',
  PRIVACY:"/privacy",
  TNC:"/tnc"


};
